(function () {
    try {

        const SelectorsDictionary = {
            ConfigModal: 'div#CC-modal',
            ConfigTab: 'section.hpe-configuration-tab',
            ConfigTabHeader: 'header.hpe-configuration-tab__header',
            ActiveConfigTab: 'section.hpe-configuration-tab--active',
            AppOS: 'app-operating-systems',
            OsCheckboxes: 'app-operating-systems input[type="checkbox"]',
            OsOptionRow: 'div.operatingSystemCB',
            OsOptionLabel: 'div.operatingSystemCBL label',
            FinalizeCta: 'button#addChCProduct, button#getQuote',
            SummaryOptionLabels: 'app-current-configuration label.hpe-config-option__label',
        };

        const BODY_CLASS = 'fe-hpe-4066';
        const WINDOWS_OS_NAME = 'Windows Server';
        const OS_TAB_NAME = 'Operating System';

        let txt = {
            HeadsUp: 'Your server’s best friend',
            Subtext: 'Add Windows Server 2025 now for safer, smarter workload management.',
            SelectOS: 'Customize to select Windows Server 2025',
            ContinueWithoutOS: 'Customize without an operating system',
        };

        let skipIntercept = false;
        let interceptedElement = null;
        let modalDismissed = false;

        // The configurator only renders app-operating-systems while the OS tab is
        // active, and only renders the summary while it is expanded. OS selection is
        // cached here so it can be read from any tab.
        let osState = {osSelected: false, windowsSelected: false, osTabIndex: -1};

        /**
         * Returns the visible CC-modal element (handles duplicate div#CC-modal on page)
         * @returns {jQuery}
         */
        function getVisibleModal() {
            return jQuery(SelectorsDictionary.ConfigModal).filter(':visible');
        }

        /**
         * Checks if the OS tab is currently active
         * @returns {boolean}
         */
        function isOnOsTab() {
            return jQuery(SelectorsDictionary.AppOS).is(':visible');
        }

        /**
         * Returns the config tab sections in display order
         * @returns {Element[]}
         */
        function getConfigTabs() {
            return Array.from(document.querySelectorAll(SelectorsDictionary.ConfigTab));
        }

        /**
         * Reads the rendered OS tab into osState. No-op when the OS tab is not active.
         */
        function syncOsState() {
            if (!isOnOsTab()) return;

            const checkedLabels = Array.from(document.querySelectorAll(SelectorsDictionary.OsCheckboxes))
                .filter(function (input) {
                    return input.checked;
                })
                .map(function (input) {
                    return input.closest(SelectorsDictionary.OsOptionRow)?.querySelector(SelectorsDictionary.OsOptionLabel)?.textContent || '';
                });

            osState.osSelected = checkedLabels.length > 0;
            osState.windowsSelected = checkedLabels.some(function (label) {
                return label.includes(WINDOWS_OS_NAME);
            });
            osState.osTabIndex = getConfigTabs().indexOf(document.querySelector(SelectorsDictionary.ActiveConfigTab));
        }

        /**
         * Returns the index of the OS tab, or -1 when this configuration has none.
         * Falls back to the English tab name until the OS tab has been visited.
         * @returns {number}
         */
        function getOsTabIndex() {
            if (osState.osTabIndex > -1) return osState.osTabIndex;
            return getConfigTabs().findIndex(function (tab) {
                return tab.textContent.includes(OS_TAB_NAME);
            });
        }

        /**
         * Checks if any OS option is selected
         * @returns {boolean}
         */
        function hasOsSelected() {
            syncOsState();
            window.feHPEB2C?.log(feProjectId + ': hasOsSelected=' + osState.osSelected);
            return osState.osSelected;
        }

        /**
         * Returns true if a Windows Server OS is in the config (brand name, not localized).
         * Prefers the expanded summary, then the rendered OS tab, then the cached state.
         */
        function hasWindowsInConfig() {
            const summaryLabels = jQuery(SelectorsDictionary.SummaryOptionLabels).toArray();
            if (summaryLabels.length > 0) {
                return summaryLabels.some(function (el) {
                    return el.textContent.includes(WINDOWS_OS_NAME);
                });
            }
            syncOsState();
            return osState.windowsSelected;
        }

        let finalizeCtaHooked = false;

        /**
         * Hooks the primary CTA (Add to cart or Request a quote) via
         * modal-level delegation. Fires a distinct event for each CTA when
         * Windows Server OS is in the config.
         */
        function hookFinalizeCta() {
            if (finalizeCtaHooked) return;
            const modal = getVisibleModal()[0];
            if (!modal) return;

            finalizeCtaHooked = true;
            modal.addEventListener('click', function (e) {
                const btn = e.target.closest(SelectorsDictionary.FinalizeCta);
                if (!btn) return;
                if (!hasWindowsInConfig()) return;

                let linkName;
                if (btn.id === 'addChCProduct') {
                    linkName = 'mp:b2c-configurator:add-to-cart-windows-os-selected';
                } else if (btn.id === 'getQuote') {
                    linkName = 'mp:b2c-configurator:request-a-quote-windows-os-selected';
                } else {
                    return;
                }
                feTrackMetrics('new.link', {link_name: linkName});
                window.feHPEB2C?.log(feProjectId + ': fired ' + linkName);
            }, true);
        }

        /**
         * Creates the modal overlay and appends it to the config modal
         */
        function createModal() {
            if (jQuery('#fe-4066-os-modal').length > 0) return;

            let modalHtml = `
            <div id="fe-4066-os-modal" class="fe-4066-overlay" style="display:none;">
                <div class="fe-4066-modal">
                    <button class="fe-4066-close" aria-label="Close">&times;</button>
                    <p class="fe-4066-title">${txt.HeadsUp}</p>
                    <p class="fe-4066-subtext">${txt.Subtext}</p>
                    <div class="fe-4066-actions">
                        <button class="fe-4066-btn-select">${txt.SelectOS}</button>
                        <button class="fe-4066-btn-continue">${txt.ContinueWithoutOS}</button>
                    </div>
                </div>
            </div>
        `;

            getVisibleModal().append(modalHtml);

            jQuery('#fe-4066-os-modal .fe-4066-close').on('click', dismissModal);
            jQuery('#fe-4066-os-modal .fe-4066-btn-select').on('click', function () {
                feTrackMetrics('new.link', {link_name: 'mp:b2c-configurator:select-windows-cta'});
                onSelectOs();
            });
            jQuery('#fe-4066-os-modal .fe-4066-btn-continue').on('click', function () {
                feTrackMetrics('new.link', {link_name: 'mp:b2c-configurator:customize-without-os-cta'});
                onContinueWithoutOs();
            });
            jQuery('#fe-4066-os-modal').on('click', function (e) {
                if (jQuery(e.target).is('.fe-4066-overlay')) {
                    dismissModal();
                }
            });
        }

        /**
         * Shows the OS reminder modal
         */
        function showModal() {
            window.feHPEB2C?.log(feProjectId + ': showModal');
            jQuery('#fe-4066-os-modal').fadeIn(200);
        }

        /**
         * Closes the modal
         */
        function closeModal() {
            window.feHPEB2C?.log(feProjectId + ': closeModal');
            jQuery('#fe-4066-os-modal').fadeOut(200);
        }

        /**
         * Closes the modal and takes the user to the OS tab if they are not already on it
         */
        function onSelectOs() {
            closeModal();
            interceptedElement = null;
            if (isOnOsTab()) return;

            const osTab = getConfigTabs()[getOsTabIndex()];
            osTab?.querySelector(SelectorsDictionary.ConfigTabHeader)?.click();
        }

        /**
         * Dismisses the modal without advancing — user stays put but won't see the modal again
         */
        function dismissModal() {
            window.feHPEB2C?.log(feProjectId + ': dismissModal');
            closeModal();
            modalDismissed = true;
            interceptedElement = null;
        }

        /**
         * Closes modal and re-clicks the intercepted element, bypassing our interceptor
         */
        function onContinueWithoutOs() {
            window.feHPEB2C?.log(feProjectId + ': onContinueWithoutOs');
            closeModal();
            modalDismissed = true;
            skipIntercept = true;
            if (interceptedElement) {
                interceptedElement.click();
                interceptedElement = null;
            }
        }

        /**
         * Returns true when the click should be held for the OS reminder modal:
         * leaving the OS tab with no OS, or finalizing a config that offers an OS
         * without one selected.
         * @param {Element|null} tab
         * @param {Element|null} finalizeCta
         * @returns {boolean}
         */
        function shouldIntercept(tab, finalizeCta) {
            if (modalDismissed) return false;
            if (tab?.matches(SelectorsDictionary.ActiveConfigTab)) return false;
            if (isOnOsTab()) return !hasOsSelected();
            if (!finalizeCta) return false;
            return getOsTabIndex() > -1 && !osState.osSelected;
        }

        /**
         * Intercepts config tab and finalize CTA clicks via event delegation on the
         * config modal. Uses capturing phase on the persistent CC-modal container so
         * it survives Angular destroying/recreating the tabs and footer.
         */
        let hooked = false;

        function hookNavigation() {
            if (hooked) return;
            const modal = getVisibleModal()[0];
            if (!modal) return;

            hooked = true;
            window.feHPEB2C?.log(feProjectId + ': hookNavigation (delegated)');

            modal.addEventListener('change', function (e) {
                if (!e.target.closest(SelectorsDictionary.OsCheckboxes)) return;
                setTimeout(syncOsState, 0);
            }, true);

            modal.addEventListener('click', function (e) {
                const tab = e.target.closest(SelectorsDictionary.ConfigTab);
                const finalizeCta = e.target.closest(SelectorsDictionary.FinalizeCta);

                if (!tab && !finalizeCta) return true;

                if (skipIntercept) {
                    skipIntercept = false;
                    return true;
                }

                if (shouldIntercept(tab, finalizeCta)) {
                    e.stopImmediatePropagation();
                    e.preventDefault();
                    interceptedElement = tab?.querySelector(SelectorsDictionary.ConfigTabHeader) || tab || finalizeCta;
                    showModal();
                    return false;
                }
                return true;
            }, true);
        }

        /**
         * Watches for the config modal to open, then sets up the hook
         */
        function watchForConfigModal() {
            window.feUtils.observeDom({
                selector: SelectorsDictionary.ConfigModal,
                callback: () => {
                    setTimeout(function () {
                        window.feHPEB2C?.log(feProjectId + ': getVisibleModal().length', getVisibleModal().length);
                        if (getVisibleModal().length > 0) {
                            window.feUtils.waitForConditions({
                                conditions: [SelectorsDictionary.ConfigTab],
                                activity: feProjectId + '-hook',
                                callback: () => {
                                    modalDismissed = false;
                                    interceptedElement = null;
                                    osState = {osSelected: false, windowsSelected: false, osTabIndex: -1};
                                    createModal();
                                    hookNavigation();
                                    hookFinalizeCta();
                                },
                            });
                        }
                    }, 1000);
                },
                config: {
                    attributes: true,
                    childList: false,
                    subtree: false,
                }
            });
        }

        function init() {
            $('body').addClass(BODY_CLASS);
            txt = window['FEi18n'].ask(JSON.parse(JSON.stringify(txt)));
            setTimeout(watchForConfigModal, 1000);
        }

        window.feUtils.waitForConditions({
            conditions: ['body', () => {
                return window['FEi18n']?.isReady()
            }],
            activity: feProjectId,
            callback: init,
        })

    } catch (e) {
        console.error(e);
    }
})();
